// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--uwf-sec-sty-container{
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    padding: 24px;
    gap: 15px;
}

.scl--uwf-sec-sty-container .scl--cms-components-workflowCard{
    flex: none;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/workflow/css/ursb-workflow.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,UAAU;AACd","sourcesContent":[".scl--uwf-sec-sty-container{\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    padding: 24px;\n    gap: 15px;\n}\n\n.scl--uwf-sec-sty-container .scl--cms-components-workflowCard{\n    flex: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
